/**
 * Zoom controls — wires the lightbox slider + / − buttons to the active image's
 * <drag-zoom-wrapper>, and keeps the slider in sync when zoom changes via wheel,
 * click, pinch or reset. Tiny delegated-listener singleton; safe to load per-block.
 */
(function () {
  if (window.__zoomControlsInit) return;
  window.__zoomControlsInit = true;

  function getActiveWrapper(dialog) {
    if (!dialog) return null;
    const items = dialog.querySelectorAll('.dialog-zoomed-gallery > li');
    let best = null;
    let bestArea = -1;
    const vw = window.innerWidth;
    const vh = window.innerHeight;
    items.forEach((li) => {
      const wrapper = li.querySelector('drag-zoom-wrapper');
      if (!wrapper) return;
      // Use visible AREA (both axes) so this works whether the gallery scrolls
      // horizontally or stacks vertically — picks the image actually in view.
      const r = li.getBoundingClientRect();
      const w = Math.max(0, Math.min(r.right, vw) - Math.max(r.left, 0));
      const h = Math.max(0, Math.min(r.bottom, vh) - Math.max(r.top, 0));
      const area = w * h;
      if (area > bestArea) {
        bestArea = area;
        best = wrapper;
      }
    });
    return best;
  }

  function getSlider(dialog) {
    return dialog?.querySelector('.dialog-zoom-controls__slider');
  }

  function syncSlider(dialog, scale) {
    const slider = getSlider(dialog);
    if (slider) slider.value = scale;
  }

  // Range slider input
  document.addEventListener('input', (e) => {
    const slider = e.target.closest('.dialog-zoom-controls__slider');
    if (!slider) return;
    const dialog = slider.closest('dialog');
    getActiveWrapper(dialog)?.setScale(parseFloat(slider.value));
  });

  // + / - buttons
  document.addEventListener('click', (e) => {
    const btn = e.target.closest('[data-zoom-step]');
    if (!btn) return;
    const dialog = btn.closest('dialog');
    const slider = getSlider(dialog);
    const step = parseFloat(btn.dataset.zoomStep);
    const current = parseFloat(slider?.value ?? 1);
    const next = Math.max(1, Math.min(5, current + step));
    getActiveWrapper(dialog)?.setScale(next);
    syncSlider(dialog, next);
  });

  // Keep slider in sync when scale changes via wheel / click / pinch / reset
  document.addEventListener('zoom:scale-change', (e) => {
    const dialog = e.target.closest('dialog');
    syncSlider(dialog, e.detail.scale);
  });

  // Reset slider and all wrappers when a different thumbnail is selected
  document.addEventListener('zoom-media:selected', (e) => {
    const zoomDialog = e.target.closest('zoom-dialog');
    const dialog = zoomDialog?.querySelector('dialog');
    if (!dialog) return;
    syncSlider(dialog, 1);
    dialog.querySelectorAll('drag-zoom-wrapper').forEach((w) => w.setScale?.(1));
  });
})();
